export const SECURITY_HIGH = 1;
export const SECURITY_NORMAL = 0;

export const SECURITY_OPTIONS = [
    {
        text: 'Normal',
        value: SECURITY_NORMAL,
    },
    {
        text: 'High',
        value: SECURITY_HIGH,
    },
];

export const PRIVILEGES_OWNER = 0;
export const PRIVILEGES_UNRESTRICTED = 1;
export const PRIVILEGES_LIMITED = 2;

export const PRIVILEGES_OPTIONS = [
    {
        text: 'Owner',
        value: PRIVILEGES_OWNER,
    },
    {
        text: 'Unrestricted',
        value: PRIVILEGES_UNRESTRICTED,
    },
    {
        text: 'Limited',
        value: PRIVILEGES_LIMITED,
    },
];

export const paymentMethodsByCurrency :any = {
    usd: ['card', 'us_bank_account'],
    gbp: ['card', 'bacs_debit'],
    eur: ['card', 'sepa_debit'],
    aud: ['card'],
    nzd: ['card'],
};

export const PLAN_TYPE_PRODUCT = 'product';
export const PLAN_TYPE_PREMIUM = 'tier';
